export default {
    updateFormShowingStatus(state, payload) {
        state[payload.formName].formShowing = payload.showingStatus;
    },

    updateFormData(state, payload){
        Object.assign(state.formData, payload);
    },

    saveLists(state, payload) {
        Object.assign(state.lists, payload);
    },

    savePasswordRules(state, payload) {
        state.passwordRulesData.rules = payload.rules;
    },

    updateFormWithProposedProfile(state, payload) {
        const form = state.formData;
        let prepopulated = false;

        if(payload.hasOwnProperty('info')) {
            const info = payload.info;

            form.f_name = info.f_name;
            form.l_name = info.l_name;
            form.company = info.employer;
            form.address = info.employer_address;
            form.address_two = info.employer_address_2;
            form.city = info.employer_city;
            form.state = info.employer_state;
            form.zipcode = info.employer_zip;
            form.job_title = info.job_title;
            form.phone_office = info.phone_office;
            form.phone_cell = info.phone_cell;
            form.website = info.website;
            form.timezone_name = info.timezone;

            prepopulated = true;
        }

        if(payload.hasOwnProperty('mls')) {
            const mls = payload.mls;

            form.license_title = mls.licenseTitle;
            form.agent_id = mls.agentId;
            form.agent_association = mls.mlsAssociation;

            prepopulated = true;
        }

        if(payload.hasOwnProperty('images')) {
            const images = payload.images;

            form.profileImage = images.profile;
            form.logoImage = images.logo;

            prepopulated = true;
        }

        state.prepopulatedForm = prepopulated;
    },

    updateAgentEmailAddress(state, email) {
        state.formData.email = email;
    },

    updateStepStatus(state, payload) {
        state.stepActive = payload;
    },

    updateLoading(state, payload) {
        state.loading = Object.assign({}, state.loading, payload);
    },
};